module.exports = __webpack_public_path__ + "static/media/7035_7021.a59acdaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/7035_7021.jpg
// module id = 113
// module chunks = 0